const CHANGE_SEARCH_FIELD_ACTION = 'CHANGE_SEARCH_FIELD';

const REQUEST_ROBOTS_STATE_PENDING = 'REQUEST_ROBOTS_STATE_PENDING';
const REQUEST_ROBOTS_STATE_SUCCESS = 'REQUEST_ROBOTS_STATE_SUCCESS';
const REQUEST_ROBOTS_STATE_FAILED = 'REQUEST_ROBOTS_STATE_FAILED';

const Constants = {
	CHANGE_SEARCH_FIELD_ACTION,
	REQUEST_ROBOTS_STATE_PENDING,
	REQUEST_ROBOTS_STATE_SUCCESS,
	REQUEST_ROBOTS_STATE_FAILED
};

export default Constants;


// WEBPACK FOOTER //
// ./src/constants.js